import _ from 'lodash';
import { CountMetric } from '@src/metrics/CountMetric';
import { IhmAssociateToolsCoreServiceClient } from '@services/coralservices/serviceClients/IhmAssociateToolsCoreServiceClient';

export class ATConfigService {
    static set toolsConfigPromise(value: Promise<any>) {
        this._toolsConfigPromise = value;
    }
    private static _toolsConfigPromise: Promise<any>;

    private static initForConfig(storeId: string) {
        // Never send GetZoneConfigs without a store: ATCore rejects it with a 400
        // ValidationException ("Value null at 'storeId'"). Fail fast without caching so a
        // later call made once the store is known can still load configs.
        if (!storeId || storeId === 'null' || storeId === 'undefined') {
            console.warn('Skipping GetZoneConfigs: storeId is not available yet', storeId);
            // Emit a fault metric so these missing-storeId occurrences -- the root cause of the
            // storeId=null app-freeze reported in ticket ada28fe5 -- are visible in production
            // monitoring. The hand-written CoreService client is not covered by
            // ServiceCallMetricsInterceptor, so without this the skip/reject path would be silent.
            new CountMetric('unknown', 'MissingStoreId.Fault', 'IhmFlyingDutchman', 'ATConfigService.initForConfig').count(1);
            return Promise.reject(new Error('Unable to load tool configs: storeId is not available'));
        }
        if (this._toolsConfigPromise == null) {
            const requestPromise = IhmAssociateToolsCoreServiceClient.getInstance()
                .getZoneConfigs(storeId)
                .then((response: any) => {
                    return response.body;
                })
                .catch((e: any) => {
                    console.error('Unable to load tool configs from CoreService for store ' + storeId, e);
                    // Drop the failed promise from the cache so the next caller retries instead
                    // of receiving this rejection for the rest of the page lifetime.
                    if (this._toolsConfigPromise === requestPromise) {
                        this._toolsConfigPromise = null;
                    }
                    return Promise.reject(e);
                });
            this._toolsConfigPromise = requestPromise;
        }
        return this._toolsConfigPromise;
    }

    public static async getZoneConfigs(storeId: string) {
        return this.initForConfig(storeId).then((data: any) => {
            if (!data.zones || !data.zones.length) {
                return Promise.reject('Invalid or empty store specific configs found in S3');
            }
            return _.cloneDeep(data.zones);
        });
    }

    public static async getToolConfigsByName(storeId: string, toolName: string) {
        return this.initForConfig(storeId).then((data: any) => {
            return _.cloneDeep(
                data.tools.find((toolConfig: any) => {
                    return toolConfig.toolName === toolName;
                }),
            );
        });
    }
}
